module.exports = __webpack_public_path__ + "img/female-youngchild-head.278407d0.svg";